import angular from 'angular';
import contractDetailsComponent from './contract-details.component';

let contractDetailsModule = angular
  .module('contractDetails', ['chart.js', 'ui.bootstrap'])

  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';
  })

  .component('contractDetails', contractDetailsComponent);

export default contractDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/contract-details/contract-details.js